import React, { FC } from 'react';
import { Skeleton, Stack, useMediaQuery, useTheme } from '@mui/material';

export const HeaderDetailsSkeleton: FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      flex={1}
      gap={3}
      alignItems={{ xs: 'flex-start', sm: 'center' }}
    >
      {/* Order ID */}
      <Skeleton variant="text" width={isMobile ? 160 : 120} height={20} />

      {/* Platform */}
      <Skeleton variant="text" width={isMobile ? 140 : 120} height={20} />

      {/* Dates */}
      <Skeleton variant="text" width={isMobile ? 180 : 120} height={20} />
    </Stack>
  );
};
